import { makeStyles } from 'tss-react/mui'
import { nunito_sans } from '@styles/fonts'
import Noise from 'src/assets/images/campaigns/noise.png'

const useStyles = makeStyles()((theme) => ({
  root: {
    position: 'relative',
    zIndex: '22',
    margin: theme.spacing(12, 0, 12),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: 'auto',
    marginTop: '-10rem',

    [theme.breakpoints.down('sm')]: {
      borderRadius: '44px',
      backgroundSize: 'cover',
    },
  },

  imgBox: {
    position: 'relative',
    img: {
      width: '100%',
      height: '100%',
    },
  },

  imgDesc: {
    position: 'absolute',
    bottom: 0,
    width: '100%',
    padding: theme.spacing(0, 0, 8, 8),
    background: 'linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000000 100%)',
    borderRadius: '12px',
    '@media (max-width:1150px)': {
      padding: theme.spacing(0, 0, 8, 8),
    },
    '@media (max-width:950px)': {
      padding: theme.spacing(0, 0, 6, 6),
    },
  },

  date: {
    fontFamily: nunito_sans.style.fontFamily,
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '12px',
    lineHeight: '16px',
    textTransform: 'uppercase',
    color: '#FFFFFF',
    textAlign: 'start',
    marginTop: theme.spacing(3),
    [theme.breakpoints.down('md')]: {
      marginTop: theme.spacing(2),
    },
  },
  title: {
    fontFamily: nunito_sans.style.fontFamily,
    fontStyle: 'normal',
    fontWeight: 800,
    fontSize: '48px',
    lineHeight: '54px',
    textTransform: 'uppercase',
    color: '#FFFFFF',
    textAlign: 'start',
    marginTop: theme.spacing(3),
    '@media (max-width:1050px)': {
      marginTop: theme.spacing(2),
      fontSize: '33px',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '24px',
    },
  },
  avatar: {
    width: '69px',
    height: '69px',
    [theme.breakpoints.down('md')]: {
      width: '55px',
      height: '55px',
    },
  },
  partners: {
    fontFamily: nunito_sans.style.fontFamily,
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '16px',
    textTransform: 'uppercase',
    color: '#FFFFFF',
    textAlign: 'start',
  },
  name: {
    fontFamily: nunito_sans.style.fontFamily,
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '16px',
    textTransform: 'uppercase',
    letterSpacing: '0.02em',
    color: '#000000',
    textAlign: 'start',
  },
  linkTitle: {
    width: '94%',
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    img: {
      marginTop: '8px',
      width: '23px',
    },
  },
  brandInfo: {
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing(5),
    paddingRight: theme.spacing(7),
    justifyContent: 'spaceBetween',
    '@media (max-width:1050px)': {
      marginTop: theme.spacing(3),
      paddingRight: theme.spacing(8),
    },
    '@media (max-width:850px)': {
      marginTop: theme.spacing(3),
      paddingRight: theme.spacing(6),
    },
    [theme.breakpoints.down('md')]: {
      marginTop: theme.spacing(2),
    },
  },

  btnContainer: {
    height: '100%',
    display: 'flex',
    justifyContent: 'start',
    alignItems: 'center',
  },
  recommendBtn: {
    borderColor: 'grey',
    background: 'transparent',
    color: 'white',
    '&:hover': {
      background: 'white',
      color: 'black',
      borderColor: 'black',
    },
  },
  matrixTop: {
    height: '158px',
    width: '100%',
    background:
      'linear-gradient(180deg, #FFFFFF 39.42%, rgba(255, 255, 255, 0) 100%)',
  },
  matrixBox: {
    marginTop: '-26rem',
    background: `url(${Noise.src}) #A0C0E9`,
    width: '100%',
    height: '1320px',

    '@media (max-width:1450px)': {
      height: '1180px',
    },
    '@media (max-width:1150px)': {
      height: '1070px',
    },
    [theme.breakpoints.down('md')]: {
      height: '800px',
    },
    '@media (max-width:919px)': {
      height: '950px',
    },

    '@media (max-width:425px)': {
      height: '835px',
    },
  },

  outerContainer: {
    height: 'auto',
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center',
  },

  campaignsContainer: {
    maxWidth: theme.maxWidth,
    width: '100%',
    padding: theme.spacing(0, 16),
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(0, 4),
    },
  },
  heroImg: {
    img: {
      borderRadius: '20px',
      [theme.breakpoints.down('md')]: {
        borderRadius: '14px',
      },
    },
  },
  zenModeImg: {
    backgroundImage: `none`,
    border: '1px solid black',
    borderRadius: '20px',
    height: '400px',
  },
  zenModeWithBg: {
    backgroundImage: `none`,
    background: `none`,
  },
}))

export default useStyles
